<!-- 登录页面 -->
<template>
	<div class="d-flex">
		<div style="width: 70%;">
			<img src="@/image/1a.png" style="width: 100%;height: 100%;">
		</div>
		<div style="width: 30%">
			<div style="width: 100%;height: 60px;border-bottom: 1px solid #184aff;display: flex;align-items: center;">
				<div class="d-flex align-items-center" style="margin-left: 10px;width: 240px;">
					<img src="@/image/qklogo.png" style="width: 28px;height: 28px;border-radius: 10px;" />
					<div style="font-size: 15px;margin-left: 8px;font-weight: 800;color: #22449b;">诚晖仓库管理系统</div>
				</div>
			</div>
			<div style="height: 57%;">
				<div class="d-flex" style="align-items: center;width: 100%;justify-content: center;margin-top: 80px;font-weight: 800;">
					<p>诚晖仓库·云账号登录</p>
				</div>
				<div style="margin-left: 50px;margin-right: 50px;">
					<el-form ref="ruleForm" :rules="rules" :model="form">
						<el-form-item prop="username"><el-input v-model="form.username" size="medium" type="password" placeholder="请输入用户名"></el-input></el-form-item>
						<el-form-item prop="password"><el-input v-model="form.password" size="medium" type="password" placeholder="请输入密码"></el-input></el-form-item>
						<el-button type="warning" size="medium" class="w-100" @click="submits(1)" :loading="loading">一键登录（开发者权限点击登录）</el-button>
						<!-- <div class="d-flex mt-1 mb-1">
							<el-button size="medium" class="texx" type="warning" @click="submits(2)" :loading="loading">仓库管理</el-button>
							<el-button size="medium" class="texx" type="warning" @click="submits(3)" :loading="loading">销售经理</el-button>
							<el-button size="medium" class="texx" type="warning" @click="submits(4)" :loading="loading">采购经理</el-button>
							<el-button size="medium" class="texx" type="warning" @click="submits(5)" :loading="loading">生产经理</el-button>
						</div> -->
						<el-form-item>
							<el-button type="primary" size="medium" class="w-100" @click="submit" :loading="loading">{{ loading ? '登录中...' : '立即登录' }}</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div style="">
				<div class="d-flex" style="align-items: center;width: 100%;justify-content: center;font-size: 10px;color: #9c9c9c;">
					<!-- <p>千客ERP云多端支持</p> -->
				</div>
				<!-- <div style="display: flex;justify-content: center;margin-left: 30px;margin-right: 30px;">
					<div style="display: flex;justify-content: center;align-items: center;flex-flow: column;font-size: 10px;color: #9c9c9c;width: 20%;">
						<img src="@/image/windows.png">
						<p>Windows</p>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;flex-flow: column;font-size: 10px;color: #9c9c9c;width: 20%;">
						<img src="@/image/mac.png">
						<p>Mac</p>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;flex-flow: column;font-size: 10px;color: #9c9c9c;width: 20%;">
						<img src="@/image/iphone.png">
						<p>iPhone</p>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;flex-flow: column;font-size: 10px;color: #9c9c9c;width: 20%;">
						<img src="@/image/ipad.png">
						<p>iPad</p>
					</div>

					<el-popover placement="right" width="200" trigger="click" style="display: flex;justify-content: center;align-items: center;flex-flow: column;font-size: 10px;color: #9c9c9c;width: 20%;">
					  <div>
						  <img src="@/image/xz.png" style="width: 170px;height: 170px;">
					  </div>
					  <div  slot="reference">
					  	<img src="@/image/android.png">
					  	<p>Android</p>
					  </div>
					</el-popover>

				</div> -->
				<!-- <div style="display: flex;justify-content: center;font-size: 10px;color: #9c9c9c;">
					<p @click="">用户协议</p>
					<p style="margin-left: 5px;margin-right: 5px;">|</p>
					<p @click="">隐私政策</p>
				</div>
				<div style="display: flex;justify-content: center;font-size: 10px;">
					<a href="https://beian.miit.gov.cn" style="text-decoration-line: none; color: #9c9c9c;">粤ICP备2021151405号</a>
				</div> -->
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
			<span>
				<div>【诚晖仓库管理系统】更新日志</div>
				<div class="mt-2" style="color: #ff0000;">版本更新内容：</div>
				<div>1.调整入仓业务逻辑</div>
				<div>2.调整出仓业务逻辑</div>
				<div>3.新增客户计费，支持sku模式</div>
				<div>4.优化已知问题</div>
				<div class="mt-2 d-flex">
					<p>内测版本号：v1.0.12</p>
					<p style="color: #ff0000;margin-left: 5px;">(更新↑)</p>
				</div>
				<div>版本更新时间：2024-09-02</div>
				<!-- <div class="mt-2" style="color: #ff0000;">版本计划：</div> -->
				<!-- <div style="color: #b9b9b9;">1.新增财务计费的流水面板</div> -->
				<!-- <div class="mt-2" style="color: #ff0000;">计划时间：2024-03-29</div> -->
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'; // 引入vuex 拿到 全局 公共数据
export default {
	name: 'Home',
	data() {
		return {
			loading: false,
			form: {
				username: '',
				password: ''
			},
			rules: {
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
			},
			centerDialogVisible: true,
		};
	},
	// 生命周期
	computed: {
		...mapGetters(['/adminIndex'])
	},
	mounted() {

	},
	methods: {
		submit() {
			this.$refs.ruleForm.validate(e => {
				if (!e) return;
				// 提交表单
				this.loading = true;
				this.axios
					.post('/admin/login', this.form)
					.then(res => {
						// this.$message('密码错误');
						console.log(res)
						// 存储到vuex
						let data = res.data.data;
						// 存储到本地存储
						this.$store.commit('login', data);
						// 存储权限规则
						if (data.role && data.role.rules) {
							window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules));
						}
						// 生成后台菜单
						this.$store.commit('createNavBar', data.tree);
						// 成功提示
						this.$message('登录成功');
						this.loading = false;
						// 跳转后台首页
						this.$router.push({ name: 'index' });
					})
					.catch(err => {
						this.loading = false;
					});
			});
		},
		submits(e) {
			if(e == 1){
				this.form = {
					username: 'qfy0752',
					password: 'qfy0752'
				}
			}else if(e == 2){
				this.form = {
					username: 'cs1001',
					password: 'cs1001'
				}
			}else if(e == 3){
				this.form = {
					username: 'cs1002',
					password: 'cs1002'
				}
			}else if(e == 4){
				this.form = {
					username: 'cs1003',
					password: 'cs1003'
				}
			}else{
				this.form = {
					username: 'cs1004',
					password: 'cs1004'
				}
			}
		}
	}
};
</script>

<style>
	body{
		overflow: hidden;
	}
	.texx{
		width: 23%;font-size: 12px;color: #fff;
	}
</style>
